import type { NavItemDto } from '@/lib/sanity/dto';
import { BaseLink } from './BaseLink';

type NavLinkProps = {
    item: NavItemDto;
    isActive?: boolean;
    /** The open page lies below this item's page — announced as the current section. */
    isAncestor?: boolean;
    className?: string;
    onClick?: () => void;
};

export function NavLink({ item, isActive, isAncestor, className, onClick }: NavLinkProps) {
    const isAnchor = Boolean(item.anchor);
    const ariaCurrent = isActive ? (isAnchor ? 'true' : 'page') : isAncestor ? 'true' : undefined;

    return (
        <BaseLink
            item={item}
            className={className}
            ariaCurrent={ariaCurrent}
            ariaHaspopup={item.openInModal ? 'dialog' : undefined}
            scroll={item.openInModal ? false : undefined}
            onClick={onClick}
        />
    );
}
